/* esm.sh - hast-util-whitespace@3.0.0 */
var r=/[ \t\n\f\r]/g;function o(e){return typeof e=="object"?e.type==="text"?t(e.value):!1:t(e)}function t(e){return e.replace(r,"")===""}export{o as whitespace};
//# sourceMappingURL=hast-util-whitespace.mjs.map